import { Button, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useToggle } from '/@/hooks/toggle/useToggle';
import { _ } from '/@/locale';
import ModalV2 from '../bayer/modal-v2';

const PrivacyDisclaimer = ({
    message = _(
        'La siguiente funcionalidad contiene información sensible de la compañía y compartirlo con gente ajena a la organización puede tener implicancias legales negativas.'
    ),
    warning,
    crop,
    title = _('Contenido sensible'),
}: {
    crop: string;
    warning: string;
    title?: string;
    message?: string;
}) => {
    const { open: showDisclaimer, toggle } = useToggle();

    useEffect(() => {
        toggle();
    }, []);

    return (
        <ModalV2
            open={showDisclaimer}
            onClose={toggle}
            title={title}
            actionsProps={{ sx: { justifyContent: 'flex-end' } }}
            actions={
                <Button variant='contained' color='secondary' onClick={toggle}>
                    {_('Aceptar')}
                </Button>
            }
        >
            <Stack spacing={2} sx={{ px: 2 }}>
                <Typography variant='body1' color='primary' align={'center'}>
                    {message}
                </Typography>

                {warning && (
                    <Typography variant='body1' color='primary' align={'center'}>
                        {warning}
                    </Typography>
                )}
            </Stack>
        </ModalV2>
    );
};

export default PrivacyDisclaimer;
